import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./utils/axios";
import moment from "moment-timezone";
import "@/assets/tailwind.css";
import Swal from "sweetalert2";
import GlobalLoading from "@/components/svgs/LoadingSvg.vue";
import SemanticVersion from "@/components/common/SemanticVersion.vue";

const app = createApp(App);
app.use(store);
app.use(router);
app.provide("$router", router);
app.provide("$axios", axios);
app.provide("$store", store);
app.provide("$moment", moment);
app.provide("$swal", Swal);
app.component("LoadingSVG", GlobalLoading);
app.component("SemanticVersion", SemanticVersion);
app.mount("#app");
